import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import random from "lodash/fp/random";
import flow from "lodash/fp/flow";
import find from "lodash/fp/find";
import isString from "lodash/fp/isString";

class Controller {
  constructor(Events, $injector, $mdDialog) {
    "ngInject";

    this.selected = [];
    this.Events = Events;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.enableEdit = false;
  }

  $onInit() {
    const removeSource = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.name = item.note ? item.name + " - " + item.note : item.name;

      return item;
    };
    const getUniqueIndex = () => random(1, 50000);

    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const markDisabled = (item) => {
      item.isDisabled = true;
      return item;
    };
    const addIndex = (item) => {
      item.index = getUniqueIndex() + getUniqueIndex();

      return item;
    };

    this.items = flow([map(markDisabled), map(addIndex)])(this.items);
    this.onAutoCompleteSearch = (text) => {
      if (isString(text)) {
        const request = this.$injector.get(this.resource).search(text);
        return request.$promise.then((list) => map(removeSource)(list.hits));
      }
    };

    this.onAutoCompleteSelect = (item, index) => {
      if (item.name) {
        const isAdded = find((obj) => obj.name === item.name.name)(this.items);

        if (!isAdded) {
          this.items[index] = assign(item.name, {
            isDisabled: item.isDisabled,
            index: getUniqueIndex(),
          });
        } else {
          this.items[index] = {
            isDisabled: false,
            name: "",
            index: getUniqueIndex(),
          };
          this.Events.emit(showNotificationEvent, {
            message: `This station ${item.name.name} is already added.`,
          });
        }
      }
    };

    this.removeItem = (index, item) => {
      if (item.name) {
        const confirm = this.$mdDialog
          .confirm()
          .title(`Are you sure you want to remove "${item.name}"?`)
          .textContent("If you chose to remove it you can add it again.")
          .ok("Remove")
          .cancel("Cancel");

        this.$mdDialog.show(confirm).then(
          () => {
            const options = { title: this.title };

            options[this.name] = this.items;
            this.items.splice(index, 1);
            this.Events.emit(this.eventName, options);
          },
          () => {}
        );
      } else {
        this.items.splice(index, 1);
      }
    };

    this.confirmItem = (index, item) => {
      if (item && item.name && item._id) {
        const options = { title: this.title };
        options[this.name] = this.items;

        this.items[index].isDisabled = true;
        this.Events.emit(this.eventName, options);
      }
    };

    this.editItem = (index) => {
      this.items[index].isDisabled = false;
    };

    this.addItem = () => {
      this.items.push({ isDisabled: false, name: "", index: getUniqueIndex() });
    };

    this.editSorting = () => {
      this.enableEdit = true;
    };

    this.confirm = () => {
      const options = { title: this.title };
      options[this.name] = this.items;

      this.enableEdit = false;
      this.Events.emit(this.eventName, options);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/sortableList/sortableList.controller.js